/**
 * Таблиця транслітерації українських літер у латиницю.
 * М'який знак (`ь`) транслітерується як порожній рядок.
 */
export const TRANSLIT_MAP = {
	'а': 'a', 'б': 'b', 'в': 'v', 'г': 'h', 'ґ': 'g', 'д': 'd', 'е': 'e', 'є': 'ie',
	'ж': 'zh', 'з': 'z', 'и': 'y', 'і': 'i', 'ї': 'i', 'й': 'i', 'к': 'k', 'л': 'l',
	'м': 'm', 'н': 'n', 'о': 'o', 'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'у': 'u',
	'ф': 'f', 'х': 'kh', 'ц': 'ts', 'ч': 'ch', 'ш': 'sh', 'щ': 'shch', 'ь': '',
	'ю': 'iu', 'я': 'ia',
};

/**
 * Транслітерує рядок з кирилиці в латиницю за таблицею {@link TRANSLIT_MAP}.
 * Символи, яких немає в таблиці, залишаються без змін.
 *
 * @param {string} str — вхідний рядок
 * @returns {string}
 *
 * @example
 * transliterate('Привіт') // 'Pryviit'
 */
export const transliterate = (str) =>
	str.split('').map(ch => TRANSLIT_MAP[ch.toLowerCase()] ?? ch).join('');

/**
 * Перетворює рядок у URL-безпечний slug.
 *
 * Кроки обробки:
 * 1. Переводить у нижній регістр
 * 2. Замінює пробіли на `-`
 * 3. Видаляє всі символи, крім `a-z`, `0-9`, `-`, `_`
 * 4. Стискає кілька `-` підряд в один
 * 5. Обрізає `-` на початку та в кінці
 *
 * @param {string} str — вхідний рядок (зазвичай після `transliterate`)
 * @returns {string}
 *
 * @example
 * slugify('Hello World!') // 'hello-world'
 * slugify(transliterate('Нова категорія')) // 'nova-katehoriia'
 */
export const slugify = (str) =>
	str.toLowerCase()
		.replace(/\s+/g, '-')
		.replace(/[^a-z0-9-_]/g, '')
		.replace(/-+/g, '-')
		.replace(/^-|-$/g, '');
